var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconKey(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.0891 7.24521L13.2162 6.37241C13.009 6.16521 12.8392 5.75577 12.8392 5.46217V4.22777C12.8392 3.64057 12.3595 3.16089 11.7725 3.16057H10.5376C10.2443 3.16057 9.8344 2.99049 9.6272 2.78345L8.7544 1.91065C8.33968 1.49593 7.66064 1.49593 7.24592 1.91065L6.37312 2.78409C6.16576 2.99129 5.75536 3.16089 5.46272 3.16089H4.22832C3.64192 3.16089 3.1616 3.64057 3.1616 4.22777V5.46217C3.1616 5.75465 2.99184 6.16537 2.78464 6.37241L1.91168 7.24521C1.49664 7.65993 1.49664 8.33897 1.91168 8.75433L2.78464 9.62713C2.992 9.83433 3.1616 10.2449 3.1616 10.5374V11.7718C3.1616 12.3583 3.64192 12.8386 4.22832 12.8386H5.46272C5.756 12.8386 6.16592 13.0084 6.37312 13.2154L7.24592 14.0886C7.66064 14.503 8.33968 14.503 8.7544 14.0886L9.6272 13.2154C9.83456 13.0082 10.2443 12.8386 10.5376 12.8386H11.7725C12.3595 12.8386 12.8392 12.3583 12.8392 11.7718V10.5374C12.8392 10.2436 13.0091 9.83417 13.2162 9.62713L14.0891 8.75433C14.5035 8.33897 14.5035 7.65993 14.0891 7.24521ZM7.15344 10.3996L4.8 8.04585L5.55424 7.29177L7.1536 8.89113L10.4459 5.59961L11.2 6.35369L7.15344 10.3996Z",
    fill: "#33CC99"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconKey);
export default __webpack_public_path__ + "static/media/icon-key.93a0795c765e58d44040723103c401ac.svg";
export { ForwardRef as ReactComponent };